var map = {
	"./soft/business-english.svg": 9370,
	"./soft/free-talk-main.svg": 45819,
	"./soft/free-talk.svg": 82478,
	"./soft/general-english.svg": 2820,
	"./soft/general-talk.svg": 55440,
	"./soft/grammar-main.svg": 68628,
	"./soft/grammar.svg": 24095,
	"./soft/professional-english.svg": 73083,
	"./soft/subcategories/avukat.svg": 74870,
	"./soft/subcategories/dis-ticaret-ve-lojistik.svg": 67812,
	"./soft/subcategories/doktor.svg": 25412,
	"./soft/subcategories/endustri-muhendisi.svg": 8221,
	"./soft/subcategories/finans-ve-ekonomi.svg": 26879,
	"./soft/subcategories/insaat-muhendisi.svg": 26101,
	"./soft/subcategories/insan-kaynaklari.svg": 37540,
	"./soft/subcategories/makine-muhendisi.svg": 84066,
	"./soft/subcategories/mali-musavir.svg": 87804,
	"./soft/subcategories/satis-ve-pazarlama.svg": 70731,
	"./soft/subcategories/yazilim-gelistirme.svg": 18042,
	"./soft/subcategories/yonetici.svg": 22050,
	"./soft/travel-english.svg": 59201
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30079;